export var IdCoopRole;
(function (IdCoopRole) {
    IdCoopRole[IdCoopRole["Leader"] = 0] = "Leader";
    IdCoopRole[IdCoopRole["Deputy"] = 1] = "Deputy";
    IdCoopRole[IdCoopRole["Member"] = 2] = "Member";
    IdCoopRole[IdCoopRole["Candidate"] = 3] = "Candidate";
})(IdCoopRole || (IdCoopRole = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/info-view/IdCoopRole.ts
// module id = 192
// module chunks = 3